var render = function render(){var _vm=this,_c=_vm._self._c;return (this.wanInboundUtilisationSeries.length > 0 || this.wanOutboundUtilisationSeries.length > 0)?_c('div',[_c('Chart',{attrs:{"options":_vm.chartOptions}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }